import { Modal, ModalBody, ModalContent, ModalOverlay, } from '@chakra-ui/react';
import React from 'react';
import StandardModalHeader from './StandardModalHeader';
import ModalErrorMessageBox from '../ErrorAwareAlertBox/ModalErrorMessageBox';
import { useModalErrors } from './ModalErrorProvider';
const StandardModal = ({ isOpen, onClose, variant = 'primary', children, isFullWidth, title, }) => {
    const { hasErrors, errors } = useModalErrors();
    const modalBodyPaddingX = isFullWidth ? 0 : undefined;
    return (React.createElement(Modal, { variant: variant, isOpen: isOpen, onClose: onClose },
        React.createElement(ModalOverlay, null),
        React.createElement(ModalContent, { tabIndex: -1 },
            React.createElement(StandardModalHeader, { title: title }),
            React.createElement(ModalErrorMessageBox, { hasErrors: hasErrors, errors: errors }),
            React.createElement(ModalBody, { px: modalBodyPaddingX }, children))));
};
export default StandardModal;
